import React, {Fragment} from 'react'
import styles from './MetaBlock.scss'
import {Icon} from 'common/LegacyIcon'
import {Block} from '../Block'
import {getCurrentUser} from 'lib/utils'
import {Modifier, SelectionState, EditorState} from 'draft-js'

const blockTypes = [
  {
    type: 'gallery',
    icon: 'gallery',
    label: 'Image/Gallery'
  },
  {
    type: 'map',
    icon: 'map',
    label: 'Map'
  },
  {
    type: 'climb',
    icon: 'elevation',
    label: 'Climb Replay'
  }
]

export const MetaBlock = ({appendBlock, block, blockProps}) => (
  <Block block={block} blockProps={blockProps}>
    <div className={styles.MetaBlock}>
      <h2>Insert a new block:</h2>
      <div className={styles.blockList}>
        {blockTypes.map(({type, icon, label}) => (
          <div key={type} className={styles.blockItem} onClick={() => blockProps.onChange({type})}>
            <Icon i={icon} size={40} />
            <span>{label}</span>
          </div>
        ))}
        <div className={styles.blockItem} onClick={() => makeUnstyled(block, blockProps)}>
          <Icon i='paragraph' size={40} />
          <span>Text</span>
        </div>
      </div>
      {getCurrentUser().accountLevel === 11 && <Fragment>
        <hr />
        <div className={styles.adminBlocks}>
          <span>these ones are admin-only</span>
          <div className={styles.blockItem} onClick={() => blockProps.onChange({type: 'route'})}>
            <Icon i='farthingWithFlat' size={40} />
            <span>troute embed</span>
          </div>
          <div className={styles.blockItem} onClick={() => blockProps.onChange({type: 'embed'})}>
            <Icon i='chainring' size={40} />
            <span>video embed</span>
          </div>
        </div>
      </Fragment>}
    </div>
  </Block>
)

const makeUnstyled = (block, {getEditorState, setEditorState}) => {
  const editorState = getEditorState()
  const target = SelectionState.createEmpty(block.getKey()).set('hasFocus', true)
  const newContent = Modifier.setBlockType(editorState.getCurrentContent(), target, 'unstyled')
    .set('selectionAfter', target)
  const newState = EditorState.push(
    editorState,
    newContent,
    'change-block-type'
  )
  setEditorState(newState)
}
